/* eslint-disable import/extensions */
import lti from "./lti.json";

export default lti;
